import React from 'react';
import { Box, Typography } from '@mui/material';

const NutritionTab = () => {
  return (
    <Box mt={3}>
      <Typography variant="body1" color="textSecondary" gutterBottom>
        Nutrition coming soon.
      </Typography>
    </Box>
  );
};

export default NutritionTab;
